export default __webpack_public_path__ + "static/media/Profile.6194cacd.jpg";